import {
  Buyers,
  OrderItemAttribute,
} from '@buncha/itemDetails/types/itemDetails';
import {H3Text, H6Text} from '@buncha/components/core/text';
import {StyleProp, ViewStyle} from 'react-native';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import If from '@buncha/components/conditional/If';
import ProfileIcon from '@buncha/components/core/icon/ProfileIcon';
import React from 'react';
import UserNameUpperPill from '@buncha/common/components/VipProfileIcon';
import {doubleDecimalOnlyRegex} from '@buncha/driver/shared/util';
import {styles} from './styles';

interface Props {
  customerType: string;
  buyer?: Buyers;
  isNSC2Item?: boolean;
  orderItemAttribute?: OrderItemAttribute;
  isVip?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}
const BuyerInfoCell = (props: Props) => {
  const {customerType, buyer, isNSC2Item, orderItemAttribute, isVip} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  if (!buyer) return null;
  return (
    <Box style={[styles.rowFlex, props?.containerStyle]}>
      <Box style={[styles.jcc]}>
        <ProfileIcon viewBox="-3 -2 25 25" fill={theme?.text.blue[300]} />
      </Box>
      <Box style={[styles.jcc, styles.flexBox]}>
        <If condition={customerType}>
          <UserNameUpperPill
            color={
              !isVip && buyer.hasNewCustomer
                ? theme?.text.green[100]
                : undefined
            }
            text={customerType}
          />
        </If>
        <H3Text style={[styles.nameTypo, {color: theme?.text.blue[300]}]}>
          {buyer.firstName} {buyer.lastName}
        </H3Text>
        <If
          condition={
            isNSC2Item &&
            orderItemAttribute?.weight &&
            orderItemAttribute?.units
          }>
          <H6Text
            style={{
              color: theme?.text?.blue?.[300],
              fontFamily: muliFont[600].normal,
            }}>
            Weight:{' '}
            {orderItemAttribute?.weight
              .toFixed(2)
              .replace(doubleDecimalOnlyRegex, '')}{' '}
            {orderItemAttribute?.units}
          </H6Text>
        </If>
      </Box>
    </Box>
  );
};

export default React.memo(BuyerInfoCell);
